uniform float uOpacity;

varying vec3 vColor;


void main()
{
    float strength = distance(gl_PointCoord, vec2(0.5));
    strength = 1.0 - strength;
    strength = pow(strength, 8.0);

    // Final color
    vec3 color = mix(vec3(0.0), vColor, strength);

    // Use strength as alpha to create smooth edges
    gl_FragColor = vec4(color, uOpacity * strength); // <- Alpha is controlled by strength

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}